import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;

let optionsApplied = false;

export function hasGoogleMapsKey(): boolean {
  return Boolean(GOOGLE_MAPS_API_KEY);
}

function ensureOptions(): boolean {
  if (!GOOGLE_MAPS_API_KEY) return false;
  if (!optionsApplied) {
    setOptions({
      key: GOOGLE_MAPS_API_KEY,
      v: "weekly",
      region: "US",
      libraries: ["places"],
    });
    optionsApplied = true;
  }
  return true;
}

export function loadPlacesLibrary(): Promise<google.maps.PlacesLibrary> {
  if (!ensureOptions()) {
    return Promise.reject(new Error("NEXT_PUBLIC_GOOGLE_MAPS_API_KEY is not set"));
  }
  return importLibrary("places");
}

export function loadGeocodingLibrary(): Promise<google.maps.GeocodingLibrary> {
  if (!ensureOptions()) {
    return Promise.reject(new Error("NEXT_PUBLIC_GOOGLE_MAPS_API_KEY is not set"));
  }
  return importLibrary("geocoding");
}
